import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Switch } from "../../components/ui/switch";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "../../components/ui/select";
import { identidadeDaRede } from "./redes";

// Ajustes de uma conta conectada. O que muda aqui vale para toda conversa que
// chegar por ela: o nome aparece na tela de Conexões e a fila decide quem
// atende.

const ContaModal = ({ open, onClose, conta, filas, onSalvar }) => {
  const [nome, setNome] = useState("");
  const [fila, setFila] = useState("0");
  const [ativa, setAtiva] = useState(true);
  const [salvando, setSalvando] = useState(false);

  // Reabrir o modal em outra conta tem que recarregar os campos, senão a
  // segunda edição salva os valores da primeira.
  useEffect(() => {
    if (!conta) return;

    setNome(conta.name || "");
    setFila(conta.queueId ? String(conta.queueId) : "0");
    setAtiva(Boolean(conta.isActive));
  }, [conta]);

  if (!conta) return null;

  const rede = identidadeDaRede(conta.platform);
  const Glifo = rede.icone;

  const salvar = async () => {
    setSalvando(true);

    await onSalvar(conta, {
      name: nome.trim() || conta.name,
      queueId: fila === "0" ? null : Number(fila),
      isActive: ativa
    });

    setSalvando(false);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(aberto) => !aberto && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <span
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-white"
              style={{ backgroundColor: rede.corSelo }}
            >
              <Glifo className="h-5 w-5" />
            </span>
            <div className="min-w-0 text-left">
              <DialogTitle className="truncate">{conta.name}</DialogTitle>
              <DialogDescription>
                {rede.rotulo}
                {conta.username ? ` · ${conta.username}` : ""}
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="zernio-conta-nome">Nome da conexão</Label>
            <Input
              id="zernio-conta-nome"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />
            <p className="text-xs text-muted-foreground">
              É o nome que a equipe vê na conversa e na tela de Conexões.
            </p>
          </div>

          <div className="space-y-1.5">
            <Label>Fila que recebe as conversas</Label>
            <Select value={fila} onValueChange={setFila}>
              <SelectTrigger>
                <SelectValue placeholder="Sem fila" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="0">Sem fila</SelectItem>
                {filas.map((item) => (
                  <SelectItem key={item.id} value={String(item.id)}>
                    {item.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <p className="text-xs text-muted-foreground">
              Sem fila, a conversa chega em Aguardando sem dono.
            </p>
          </div>

          <div className="flex items-start justify-between gap-4 rounded-lg border p-3">
            <div>
              <p className="text-sm font-medium">Receber conversas</p>
              <p className="text-xs text-muted-foreground">
                Desligado, a conta continua conectada mas nada novo entra no
                atendimento.
              </p>
            </div>
            <Switch checked={ativa} onCheckedChange={setAtiva} />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={salvando}>
            Cancelar
          </Button>
          <Button onClick={salvar} disabled={salvando}>
            {salvando && <Loader2 className="h-4 w-4 animate-spin" />}
            Salvar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ContaModal;
